export type Lang = 'fr' | 'en';

export const t = {
  fr: {
    nav: {
      products: 'Produits',
      resellers: 'Revendeurs',
      services: 'Services',
      about: 'À propos',
      contact: 'Contact',
      catalogue: 'Catalogue',
    },
    topbar: 'Devis volume à partir de 10 unités — Contactez-nous',
    hero: {
      title: 'Équipez vos équipes. Commandez en ligne ou demandez un devis volume.',
      subtitle: 'Tenues pro, EPI et batteries certifiées — pour revendeurs & professionnels.',
      cta1: 'Voir le catalogue',
      cta2: 'Ouvrir un compte revendeur',
    },
    trust: {
      secure: 'Paiement sécurisé',
      delivery: 'Livraison rapide',
      norms: 'Conformité & normes',
      support: 'Support B2B',
    },
    universes: {
      title: 'Nos 3 univers produits',
      vetements: {
        name: 'Vêtements Pro',
        desc: 'Tenues de travail pour industrie, médical, restauration et artisanat.',
        sub: ['Industrie & BTP', 'Médical & Soin', 'Restauration'],
      },
      epi: {
        name: 'EPI & Sécurité',
        desc: 'Équipements de protection individuelle certifiés normes européennes.',
        sub: ['Protection tête', 'Mains & pieds', 'Respiration & vision'],
      },
      batteries: {
        name: 'Batteries Pro',
        desc: 'Batteries professionnelles pour médical, industriel et systèmes de sécurité.',
        sub: ['Médical', 'Onduleurs & UPS', 'BAES & Alarmes'],
      },
      explore: 'Explorer',
    },
    howToBuy: {
      title: 'Comment acheter ?',
      direct: {
        title: 'Achat direct',
        steps: ['Choisissez votre produit', 'Ajoutez au panier', 'Validez votre commande'],
      },
      quote: {
        title: 'Devis volume',
        steps: ['Ajoutez la quantité souhaitée', 'Demandez un devis', 'Validation & livraison sous 24h'],
        note: 'À partir du seuil, tarifs dégressifs automatiques.',
      },
      thresholds: {
        title: 'Seuils devis par catégorie',
        cat: 'Catégorie',
        threshold: 'Seuil devis',
        vetements: 'Vêtements Pro',
        epi: 'EPI & Sécurité',
        batteries: 'Batteries Pro',
      },
    },
    bestsellers: {
      title: 'Meilleures ventes',
      subtitle: 'Produits les plus commandés par nos clients professionnels.',
      addCart: 'Ajouter au panier',
      quoteVol: 'Demander un devis',
      quoteMsg: 'Prix dégressifs sur devis pour ce volume.',
      fav: 'Favoris',
      inStock: 'En stock',
      lowStock: 'Stock limité',
      outStock: 'Rupture',
    },
    reseller: {
      title: 'Espace Revendeur',
      subtitle: 'Accédez aux tarifs pro, remises volume et priorité de stock.',
      advantages: [
        { title: 'Tarifs pro exclusifs', desc: 'Prix revendeur dès validation de votre compte.' },
        { title: 'Remises volume', desc: 'Paliers tarifaires dégressifs selon vos volumes.' },
        { title: 'Stock prioritaire', desc: 'Réservation de stock pour vos commandes récurrentes.' },
        { title: 'Support dédié', desc: 'Un conseiller B2B attitré à votre compte.' },
      ],
      steps: ['Remplissez le formulaire', 'Validation sous 48h', 'Accès aux prix pro'],
      cta: 'Ouvrir un compte revendeur',
      form: {
        title: "Demande d'ouverture de compte",
        company: 'Société',
        tax: 'Numéro Fiscal',
        city: 'Ville',
        email: 'Email professionnel',
        phone: 'Téléphone',
        volume: 'Volume mensuel estimé',
        categories: "Catégories d'intérêt",
        message: 'Message (optionnel)',
        submit: 'Envoyer la demande',
        success: 'Demande envoyée ! Nous vous contactons sous 48h.',
      },
    },
    cart: {
      title: 'Panier',
      empty: 'Votre panier est vide.',
      goCatalogue: 'Voir le catalogue',
      qty: 'Qté',
      unit: 'Unitaire',
      subtotal: 'Sous-total',
      total: 'Total',
      quoteLabel: 'Sur devis',
      checkoutDirect: 'Commander (achat direct)',
      checkoutQuote: 'Demander un devis',
      mixedNote: 'Votre panier contient des lignes volume. Choisissez votre parcours :',
      remove: 'Supprimer',
      toggleDirect: 'Achat direct',
      toggleQuote: 'Demande de devis',
    },
    checkout: {
      title: 'Finaliser la commande',
      name: 'Nom complet',
      company: 'Société (optionnel)',
      phone: 'Téléphone',
      email: 'Email',
      address: 'Adresse',
      city: 'Ville',
      payment: 'Mode de règlement',
      payDelivery: 'À la livraison',
      payTransfer: 'Virement bancaire',
      submit: 'Confirmer la commande',
      success: 'Commande confirmée !',
      successMsg: 'Merci pour votre commande. Vous recevrez une confirmation par email.',
      orderRef: 'Référence commande',
      track: 'Suivre ma commande (mock)',
    },
    quoteRequest: {
      title: 'Demande de devis volume',
      name: 'Nom complet',
      company: 'Société',
      phone: 'Téléphone',
      email: 'Email',
      notes: 'Précisions / notes',
      upload: 'Joindre un document (optionnel)',
      submit: 'Envoyer la demande de devis',
      success: 'Demande de devis envoyée !',
      successMsg: 'Notre équipe vous répond sous 24h avec une offre tarifaire personnalisée.',
    },
    services: {
      title: 'Services & Livraison',
      deliveryTitle: 'Délais de livraison',
      deliveryItems: [
        { label: 'Commandes standard', value: '3-5 jours ouvrés' },
        { label: 'Commandes express', value: '24-48h (surcoût)' },
        { label: 'Commandes volume (devis)', value: 'Sur accord commercial' },
      ],
      returnsTitle: 'Retours & SAV',
      returnsDesc: 'Retours acceptés sous 30 jours pour les produits non utilisés. SAV dédié aux comptes pro.',
      supportTitle: 'Support technique',
      supportDesc: "Expertise sur les normes EN/ISO, conseils de conformité et assistance à la sélection d'EPI.",
    },
    about: {
      title: 'À propos de LODISS',
      desc: 'LODISS est un distributeur B2B spécialisé en équipements de protection, vêtements professionnels et batteries industrielles & médicales. Nous accompagnons revendeurs et professionnels avec des produits certifiés et un service irréprochable.',
      valuesTitle: 'Nos valeurs',
      values: [
        { title: 'Sécurité', desc: 'Tous nos produits sont certifiés aux normes tunisiennes en vigueur.' },
        { title: 'Réactivité', desc: 'Réponse devis sous 24h, livraisons rapides, support disponible.' },
        { title: 'Partenariat', desc: 'Relations durables avec nos clients revendeurs et professionnels.' },
      ],
      contactTitle: 'Contact',
      email: 'contact@lodiss.com',
      phone: '+216 93 002 840',
      address: 'Centre Molka, Manar 2, Tunis, Tunisie',
    },
    common: {
      unitPrice: 'Prix unitaire HT (DT)',
      moq: 'Qté min.',
      quoteFrom: 'Devis dès',
      units: 'unités',
      norm: 'Normes',
      ref: 'Réf.',
      addFav: 'Ajouter aux favoris',
      removeFav: 'Retirer des favoris',
      viewProduct: 'Voir le produit',
      close: 'Fermer',
      search: 'Rechercher...',
      filter: 'Filtrer',
      sortBy: 'Trier par',
      allCat: 'Toutes catégories',
      allSectors: 'Tous secteurs',
      priceAsc: 'Prix croissant',
      priceDesc: 'Prix décroissant',
      nameAz: 'Nom A-Z',
      inStock: 'En stock uniquement',
      ht: 'HT',
      ttc: 'TTC',
      addToCart: 'Ajouter au panier',
      requestQuote: 'Demander un devis',
      quoteVolMsg: 'Pour ce volume, tarifs dégressifs sur devis.',
      volumePricing: 'Tarifs volume',
      volumePricingDesc: 'Pour des commandes dépassant le seuil, nos prix sont négociés selon vos volumes.',
      downloadSpec: 'Télécharger la fiche technique (PDF mock)',
      specs: 'Caractéristiques',
      back: 'Retour',
      myOrders: 'Mes demandes',
      noOrders: 'Aucune demande enregistrée.',
    },
    product: {
      home: 'Accueil',
      catalogue: 'Catalogue',
      productFeatures: 'Caractéristiques produit',
      techSheet: 'Fiche technique',
      tunisiaAvailability: 'Disponible en Tunisie et Maghreb',
      downloadsLabel: 'Accès aux fiches techniques/certificats',
      size: 'Taille',
      color: 'Couleur',
      qty: 'Quantité',
      minQty: 'Quantité minimum',
      unit: 'unité',
      units: 'unités',
      selectedSize: 'Taille sélectionnée',
      selectedColor: 'Couleur sélectionnée',
      seeMore: 'Voir plus',
      seeLess: 'Voir moins',
      quoteThresholdMsg: 'Au-delà de cette quantité, ce produit passe en mode devis — tarifs dégressifs sur demande.',
      quoteRedirectMsg: 'Pour cette quantité, vous serez redirigé vers le formulaire de devis.',
      lowStockMsg: 'Stock limité — {count} unités disponibles',
      inTunisiaMaghreb: 'Disponible en Tunisie et Maghreb',
      downloads: 'Téléchargements',
      techSheetsCerts: 'Fiches techniques et certificats',
      features: 'Caractéristiques',
      technicalInfo: 'Informations techniques',
      reference: 'Référence',
      brand: 'Marque',
      category: 'Catégorie',
      subcategory: 'Sous-catégorie',
      sectors: 'Secteurs',
      standards: 'Normes certifiées',
      availability: 'Disponibilité',
      moqLabel: 'MOQ',
      sameCategory: 'Produits de la même catégorie',
      viewAll: 'Voir tout',
      imageNotAvailable: 'Image non disponible',
      notFound: 'Produit non trouvé',
      errorLoading: 'Erreur lors du chargement du produit',
    },
    whatsapp: 'Devis WhatsApp',
  },
  en: {
    nav: {
      products: 'Products',
      resellers: 'Resellers',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      catalogue: 'Catalogue',
    },
    topbar: 'Volume quotes from 10 units — Contact us',
    hero: {
      title: 'Equip your teams. Order online or request a volume quote.',
      subtitle: 'Certified workwear, PPE and batteries — for resellers & professionals.',
      cta1: 'View catalogue',
      cta2: 'Open a reseller account',
    },
    trust: {
      secure: 'Secure payment',
      delivery: 'Fast delivery',
      norms: 'Compliance & standards',
      support: 'B2B support',
    },
    universes: {
      title: 'Our 3 product ranges',
      vetements: {
        name: 'Workwear',
        desc: 'Work clothing for industry, medical, catering and crafts.',
        sub: ['Industry & Construction', 'Medical & Care', 'Catering'],
      },
      epi: {
        name: 'PPE & Safety',
        desc: 'Personal protective equipment certified to European standards.',
        sub: ['Head protection', 'Hands & feet', 'Breathing & vision'],
      },
      batteries: {
        name: 'Pro Batteries',
        desc: 'Professional batteries for medical, industrial and safety systems.',
        sub: ['Medical', 'UPS & Inverters', 'Emergency lighting & Alarms'],
      },
      explore: 'Explore',
    },
    howToBuy: {
      title: 'How to buy?',
      direct: {
        title: 'Direct purchase',
        steps: ['Choose your product', 'Add to cart', 'Checkout'],
      },
      quote: {
        title: 'Volume quote',
        steps: ['Set desired quantity', 'Request a quote', 'Approval & delivery within 24h'],
        note: 'Above the threshold, automatic tiered pricing.',
      },
      thresholds: {
        title: 'Quote thresholds by category',
        cat: 'Category',
        threshold: 'Quote threshold',
        vetements: 'Workwear',
        epi: 'PPE & Safety',
        batteries: 'Pro Batteries',
      },
    },
    bestsellers: {
      title: 'Best sellers',
      subtitle: 'Most ordered products by our professional clients.',
      addCart: 'Add to cart',
      quoteVol: 'Request a quote',
      quoteMsg: 'Tiered pricing on quote for this volume.',
      fav: 'Favourites',
      inStock: 'In stock',
      lowStock: 'Low stock',
      outStock: 'Out of stock',
    },
    reseller: {
      title: 'Reseller Hub',
      subtitle: 'Access pro pricing, volume discounts and priority stock.',
      advantages: [
        { title: 'Exclusive pro pricing', desc: 'Reseller rates from account validation.' },
        { title: 'Volume discounts', desc: 'Tiered pricing based on your order volumes.' },
        { title: 'Priority stock', desc: 'Stock reservation for recurring orders.' },
        { title: 'Dedicated support', desc: 'A dedicated B2B advisor for your account.' },
      ],
    steps: ['Fill in the form', 'Validated within 48h', 'Access to pro pricing'],
    cta: 'Open a reseller account',
    form: {
      title: 'Account opening request',
      company: 'Company',
      tax: 'Tax ID Number',
      city: 'City',
      email: 'Professional email',
      phone: 'Phone',
      volume: 'Estimated monthly volume',
      categories: 'Categories of interest',
      message: 'Message (optional)',
      submit: 'Send request',
      success: 'Request sent! We will contact you within 48h.',
    },
  },
  cart: {
    title: 'Cart',
    empty: 'Your cart is empty.',
    goCatalogue: 'View catalogue',
    qty: 'Qty',
    unit: 'Unit price',
    subtotal: 'Subtotal',
    total: 'Total',
    quoteLabel: 'On quote',
    checkoutDirect: 'Checkout (direct purchase)',
    checkoutQuote: 'Request a quote',
    mixedNote: 'Your cart contains volume lines. Choose your path:',
    remove: 'Remove',
    toggleDirect: 'Direct purchase',
    toggleQuote: 'Quote request',
  },
  checkout: {
    title: 'Complete your order',
    name: 'Full name',
    company: 'Company (optional)',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    city: 'City',
    payment: 'Payment method',
    payDelivery: 'Cash on delivery',
    payTransfer: 'Bank transfer',
    submit: 'Confirm order',
    success: 'Order confirmed!',
    successMsg: 'Thank you for your order. You will receive a confirmation by email.',
    orderRef: 'Order reference',
    track: 'Track my order (mock)',
  },
  quoteRequest: {
    title: 'Volume quote request',
    name: 'Full name',
    company: 'Company',
    phone: 'Phone',
    email: 'Email',
    notes: 'Details / notes',
    upload: 'Attach a document (optional)',
    submit: 'Submit quote request',
    success: 'Quote request sent!',
    successMsg: 'Our team will respond within 24h with a personalised pricing offer.',
  },
  services: {
    title: 'Services & Delivery',
    deliveryTitle: 'Delivery times',
    deliveryItems: [
      { label: 'Standard orders', value: '3-5 business days' },
      { label: 'Express orders', value: '24-48h (surcharge)' },
      { label: 'Volume orders (quote)', value: 'Subject to commercial agreement' },
    ],
    returnsTitle: 'Returns & After-sales',
    returnsDesc: 'Returns accepted within 30 days for unused products. Dedicated after-sales for pro accounts.',
    supportTitle: 'Technical support',
    supportDesc: 'EN/ISO standards expertise, compliance advice and PPE selection assistance.',
  },
  about: {
    title: 'About LODISS',
    desc: 'LODISS is a B2B distributor specialising in protective equipment, professional workwear and industrial & medical batteries. We support resellers and professionals with certified products and outstanding service.',
    valuesTitle: 'Our values',
    values: [
      { title: 'Safety', desc: 'All our products are certified to current Tunisian standards.' },
      { title: 'Responsiveness', desc: 'Quote response within 24h, fast deliveries, available support.' },
      { title: 'Partnership', desc: 'Lasting relationships with our reseller and professional clients.' },
    ],
    contactTitle: 'Contact',
    email: 'contact@lodiss.com',
    phone: '+216 93 002 840',
    address: 'Centre Molka, Manar 2, Tunis, Tunisie',
  },
  common: {
    unitPrice: 'Unit price (DT)',
    moq: 'Min. qty',
    quoteFrom: 'Quote from',
    units: 'units',
    norm: 'Standards',
    ref: 'Ref.',
    addFav: 'Add to favourites',
    removeFav: 'Remove from favourites',
    viewProduct: 'View product',
    close: 'Close',
    search: 'Search...',
    filter: 'Filter',
    sortBy: 'Sort by',
    allCat: 'All categories',
    allSectors: 'All sectors',
    priceAsc: 'Price low to high',
    priceDesc: 'Price high to low',
    nameAz: 'Name A-Z',
    inStock: 'In stock only',
    ht: 'excl. VAT',
    ttc: 'incl. VAT',
    addToCart: 'Add to cart',
    requestQuote: 'Request a quote',
    quoteVolMsg: 'For this volume, tiered pricing on quote.',
    volumePricing: 'Volume pricing',
    volumePricingDesc: 'For orders above the threshold, prices are negotiated based on your volumes.',
    downloadSpec: 'Download datasheet (mock PDF)',
    specs: 'Specifications',
    back: 'Back',
    myOrders: 'My requests',
    noOrders: 'No requests recorded.',
  },
  product: {
    home: 'Home',
    catalogue: 'Catalogue',
    productFeatures: 'Product features',
    techSheet: 'Technical sheet',
    tunisiaAvailability: 'Available in Tunisia and Maghreb',
    downloadsLabel: 'Access to technical sheets/certificates',
    size: 'Size',
    color: 'Color',
    qty: 'Quantity',
    minQty: 'Minimum quantity',
    unit: 'unit',
    units: 'units',
    selectedSize: 'Selected size',
    selectedColor: 'Selected color',
    seeMore: 'See more',
    seeLess: 'See less',
    quoteThresholdMsg: 'Beyond this quantity, this product switches to quote mode — tiered pricing on request.',
    quoteRedirectMsg: 'For this quantity, you will be redirected to the quote form.',
    lowStockMsg: 'Limited stock — {count} units available',
    inTunisiaMaghreb: 'Available in Tunisia and Maghreb',
    downloads: 'Downloads',
    techSheetsCerts: 'Technical sheets and certificates',
    features: 'Features',
    technicalInfo: 'Technical information',
    reference: 'Reference',
    brand: 'Brand',
    category: 'Category',
    subcategory: 'Subcategory',
    sectors: 'Sectors',
    standards: 'Certified standards',
    availability: 'Availability',
    moqLabel: 'MOQ',
    sameCategory: 'Products in the same category',
    viewAll: 'View all',
    imageNotAvailable: 'Image not available',
    notFound: 'Product not found',
    errorLoading: 'Error loading product',
  },
  whatsapp: 'WhatsApp Quote',
},
};

export type Translations = typeof t.fr;

